export const startTemplate = [
  {
    htmlTitle: 'To Do',
    type: 10,
    children: [
      {
        htmlTitle: 'First Task',
        type: 6
      }
    ]
  },
  {
    htmlTitle: 'Notes',
    type: 10,
    children: [
      {
        htmlTitle: 'My first notes',
        type: 8
      }
    ]
  },
  {
    htmlTitle: 'Projects',
    type: 10,
    children: [
      {
        htmlTitle: 'My project notebook',
        type: 19
      }
    ]
  }
];

export const guideTemplate = [
  {
    name:
      'Hi 👋, Welcome to Context! (Open this note by hovering here and clicking the blue button to the right)',
    htmlTitle:
      '<p><strong>Hi 👋, Welcome to Context!</strong> <em>(Open this note by hovering here and clicking the blue button to the right)</em></p>',
    type: 8,
    flair: {
      likely: [0, 0],
      progress: 0,
      rating: 0,
      enabled: [],
      check: false
    },
    lastModified: '2023-02-01T21:47:41.836Z',
    children: [
      {
        name: 'You did it! You opened this note into the main workspace!',
        htmlTitle:
          '<p><strong>You did it! </strong>You opened this note into the main workspace!</p>',
        type: 0,
        flair: {
          progress: 0,
          enabled: [],
          rating: 0,
          check: false,
          likely: [0, 0]
        },
        lastModified: '2022-12-16T15:23:35.396Z'
      },
      {
        name:
          "Context is all about organizing the stuff we're thinking about so we can make progress on the things we're working on.",
        htmlTitle:
          "<p>Context is all about organizing the stuff we're thinking about so we can make progress on the things we're working on.</p>",
        type: 0,
        flair: {
          check: false,
          likely: [0, 0],
          enabled: [],
          rating: 0,
          progress: 0
        },
        lastModified: '2023-01-30T15:36:31.114Z'
      },
      {
        name: 'It gives us an approach to making progress!',
        htmlTitle: '<p>It gives us an approach to making progress!</p>',
        type: 0,
        flair: {
          likely: [0, 0],
          check: false,
          progress: 0,
          enabled: [],
          rating: 0
        },
        lastModified: '2023-01-19T18:12:52.289Z'
      },
      {
        name: 'We do that by organizing our thoughts into structured notes.',
        htmlTitle:
          '<p>We do that by<strong> organizing our thoughts into structured notes.</strong></p>',
        type: 0,
        flair: {
          enabled: [],
          check: false,
          progress: 0,
          likely: [0, 0],
          rating: 0
        },
        lastModified: '2023-01-30T15:36:29.647Z'
      },
      {
        name: 'And by giving our notes context so we can see things clearly.',
        htmlTitle:
          '<p>And by <strong>giving our notes context </strong>so we can see things clearly.</p>',
        type: 0,
        flair: {
          enabled: [],
          check: false,
          rating: 0,
          progress: 0,
          likely: [0, 0]
        },
        lastModified: '2023-01-30T15:36:28.442Z'
      },
      {
        name:
          "That way it's easier to work through ideas and come up with what we need to do next.",
        htmlTitle:
          "<p>That way it's easier to work through ideas and come up with what we need to do next.</p>",
        type: 0,
        flair: {
          check: false,
          likely: [0, 0],
          enabled: [],
          rating: 0,
          progress: 0
        },
        lastModified: '2023-01-30T15:36:27.866Z'
      },
      {
        name: 'So how do we make structured notes?',
        htmlTitle: '<p>So how do we make structured notes?</p>',
        type: 0,
        flair: {
          check: false,
          progress: 0,
          likely: [0, 0],
          enabled: [],
          rating: 0
        },
        lastModified: '2023-01-30T15:37:29.513Z',
        children: [
          {
            name: 'We build structure by nesting! This is a nested note!',
            htmlTitle: '<p>We build structure by nesting! This is a nested note!</p>',
            type: 0,
            flair: {
              likely: [0, 0],
              rating: 0,
              enabled: [],
              check: false,
              progress: 0
            },
            lastModified: '2023-01-27T15:56:29.846Z'
          },
          {
            name: "Structure lets us organize and categorize, so we can see what we've got.",
            htmlTitle:
              "<p>Structure lets us organize and categorize, so we can see what we've got.</p>",
            type: 0,
            flair: {
              progress: 0,
              check: false,
              enabled: [],
              rating: 0,
              likely: [0, 0]
            },
            lastModified: '2023-01-30T15:36:48.050Z'
          },
          {
            name:
              "This is a bit like sorting clean laundry into piles. It's should be pretty intuitive and organic.",
            htmlTitle:
              "<p>This is a bit like sorting clean laundry into piles. It's should be pretty intuitive and organic.</p>",
            type: 0,
            flair: {
              likely: [0, 0],
              enabled: [],
              check: false,
              progress: 0,
              rating: 0
            },
            lastModified: '2023-01-30T15:37:10.746Z'
          },
          {
            name: 'Just hit TAB on any note and it will nest beneath the one above it.',
            htmlTitle:
              '<p>Just hit <strong>TAB </strong>on any note and it will nest beneath the one above it.</p>',
            type: 0,
            flair: {
              enabled: [],
              likely: [0, 0],
              rating: 0,
              progress: 0,
              check: false
            },
            lastModified: '2023-01-30T15:37:29.513Z'
          },
          {
            name:
              'Want to try? Click on this line here, and hit TAB. You can also un-nest something by hitting SHIFT + TAB . Try it right here to bring this note back out.',
            htmlTitle:
              '<p>Want to try? Click on this line here, and hit <strong>TAB.</strong> You can also un-nest something by hitting <strong>SHIFT </strong>+ <strong>TAB</strong> . Try it right here to bring this note back out.</p>',
            type: 0,
            flair: {
              rating: 0,
              progress: 0,
              likely: [0, 0],
              enabled: [],
              check: false
            },
            lastModified: '2023-01-30T15:36:21.833Z'
          },
          {
            name:
              'And you can collapse or expand your nested items by clicking on the little arrow thing at the beginning of each line. Try expanding this note.',
            htmlTitle:
              '<p>And you can <strong>collapse or expand</strong> your nested items by clicking on the little arrow thing at the beginning of each line. Try expanding this note.</p>',
            type: 0,
            flair: {
              rating: 0,
              progress: 0,
              check: false,
              enabled: [],
              likely: [0, 0]
            },
            lastModified: '2023-02-01T21:53:53.828Z',
            children: [
              {
                name: 'https://i.giphy.com/media/IdfZoqnHEEqFkXBUFO/giphy.gif',
                htmlTitle:
                  '<p><a href="https://i.giphy.com/media/IdfZoqnHEEqFkXBUFO/giphy.gif" target="_blank">https://i.giphy.com/media/IdfZoqnHEEqFkXBUFO/giphy.gif</a></p>',
                type: 0,
                flair: {
                  enabled: ['cardify'],
                  likely: [0, 0],
                  check: false,
                  progress: 0,
                  rating: 0
                },
                lastModified: '2022-12-16T14:03:26.299Z'
              },
              {
                name:
                  'Easy. You can collapse nested notes the same way. It helps to be able to make some notes, and then tuck them away to focus on other stuff. Go ahead and collapse that same note again.',
                htmlTitle:
                  '<p>Easy. You can collapse nested notes the same way. It helps to be able to make some notes, and then tuck them away to focus on other stuff. Go ahead and collapse that same note again.</p>',
                type: 0,
                flair: {
                  rating: 0,
                  progress: 0,
                  likely: [0, 0],
                  enabled: [],
                  check: false
                },
                lastModified: '2022-12-16T14:10:05.106Z'
              }
            ]
          },
          {
            name:
              'You can even do this from the keyboard! Put your cursor on this note and try hitting CTRL + DOWN or CTRL + UP (or whatever people do on macs).',
            htmlTitle:
              '<p>You can even do this from the keyboard! Put your cursor on this note and try hitting CTRL + DOWN or CTRL + UP (or whatever people do on macs).</p>',
            type: 0,
            flair: {
              likely: [0, 0],
              check: false,
              rating: 0,
              progress: 0,
              enabled: []
            },
            lastModified: '2023-01-30T15:49:40.660Z',
            children: [
              {
                name: '👻Boo!',
                htmlTitle: '<p>👻Boo!</p>',
                type: 0,
                flair: {
                  rating: 0,
                  likely: [0, 0],
                  enabled: [],
                  progress: 0,
                  check: false
                },
                lastModified: '2023-01-27T15:58:23.451Z'
              }
            ]
          }
        ]
      },
      {
        name:
          "But now we have a big wall of nested bullets. As it grows it's going to be harder and harder to see what's going on.",
        htmlTitle:
          "<p>But now we have a<strong> big wall of nested bullets.</strong> As it grows it's going to be harder and harder to see what's going on.</p>",
        type: 0,
        flair: {
          likely: [0, 0],
          enabled: [],
          check: false,
          rating: 0,
          progress: 0
        },
        lastModified: '2022-12-19T15:23:38.846Z'
      },
      {
        name: "I've got an idea - Lets add some context!",
        htmlTitle: "<p>I've got an idea - Lets add some context!</p>",
        type: '3',
        flair: {
          rating: 0,
          check: false,
          enabled: [],
          likely: [0, 0],
          progress: 0
        },
        lastModified: '2023-01-27T16:42:24.723Z',
        children: [
          {
            name:
              "See that blue icon? Looks nice, right? Nice and clear that it's an idea. I changed the bullet icon to an idea icon to give it some context.",
            htmlTitle:
              "<p>See that blue icon? Looks nice, right? Nice and clear that it's an idea. I changed the <strong>bullet </strong>icon to an <strong>idea </strong>icon to give it some context.</p>",
            type: 0,
            flair: {
              check: false,
              rating: 0,
              progress: 0,
              likely: [0, 0],
              enabled: []
            },
            lastModified: '2023-01-30T15:38:27.476Z'
          },
          {
            name:
              'We use icons to add differentiate our notes and include extra information we can get at a glance. ',
            htmlTitle:
              '<p>We use icons to add differentiate our notes and include extra information we can get at a glance. </p>',
            type: 0,
            flair: {
              enabled: [],
              check: false,
              progress: 0,
              likely: [0, 0],
              rating: 0
            },
            lastModified: '2022-12-16T13:53:27.252Z'
          },
          {
            name: "Now it's easy for me to see what kind of notes I've got here at a glance.",
            htmlTitle:
              "<p>Now it's easy for me to see what kind of notes I've got here at a glance.</p>",
            type: 0,
            flair: {
              enabled: [],
              progress: 0,
              check: false,
              likely: [0, 0],
              rating: 0
            },
            lastModified: '2022-12-16T14:06:03.667Z'
          },
          {
            name:
              "Let's try it! Click on this task icon and choose a new icon. Which ever you like!",
            htmlTitle:
              "<p>Let's try it! Click on this task icon and choose a new icon. Which ever you like!</p>",
            type: 6,
            flair: {
              check: false,
              enabled: [],
              likely: [0, 0],
              rating: 0,
              progress: 0
            },
            lastModified: '2023-01-30T15:38:56.569Z'
          },
          {
            name: 'Here are some tips on icons.',
            htmlTitle: '<p>Here are some tips on icons.</p>',
            type: 2,
            flair: {
              progress: 0,
              rating: 0,
              enabled: [],
              likely: [0, 0],
              check: false
            },
            lastModified: '2023-01-20T14:19:14.832Z',
            children: [
              {
                name:
                  "There isn't a \"right\" icon, just the one that is right for now. So don't worry about trying an icon to see how it feels, it's easy to change.",
                htmlTitle:
                  "<p><strong>There isn't a \"right\" icon</strong>, just the one that is right for now. So don't worry about trying an icon to see how it feels, it's easy to change.</p>",
                type: 0,
                flair: {
                  enabled: [],
                  rating: 0,
                  progress: 0,
                  likely: [0, 0],
                  check: false
                },
                lastModified: '2023-01-19T18:17:54.331Z'
              },
              {
                name:
                  'Icons don\'t really change the note. If you switch a bullet icon to a "sheet" or a "folder", it doesn\'t get new properties. It is just a way to mark how we want to think about the note.',
                htmlTitle:
                  '<p><strong>Icons don\'t really change the note</strong>. If you switch a bullet icon to a "sheet" or a "folder", it doesn\'t get new properties. It is just a way to mark how we want to think about the note.</p>',
                type: 0,
                flair: {
                  enabled: [],
                  progress: 0,
                  check: false,
                  rating: 0,
                  likely: [0, 0]
                },
                lastModified: '2023-01-19T18:17:58.164Z'
              },
              {
                name:
                  "They're a way to turn a wall of grey text into something that's clear and organized, so it's easier to see what you got, see what you're missing, and see how to move forward.",
                htmlTitle:
                  "<p><strong>They're a way to turn a wall of grey text into something that's clear and organized</strong>, so it's easier to see what you got, see what you're missing, and see how to move forward.</p>",
                type: 0,
                flair: {
                  likely: [0, 0],
                  check: false,
                  progress: 0,
                  enabled: [],
                  rating: 0
                },
                lastModified: '2023-01-30T15:39:26.147Z'
              }
            ]
          }
        ]
      },
      {
        name:
          "We use this temporary structure and these icons to organize our thoughts on the fly, and then work through them, until we've figured something out and have a plan for moving forward.",
        htmlTitle:
          "<p>We use this temporary structure and these icons to organize our thoughts on the fly, and then work through them, until we've figured something out and have a plan for moving forward.</p>",
        type: 4,
        flair: {
          progress: 0,
          rating: 0,
          check: false,
          likely: [0, 0],
          enabled: []
        },
        lastModified: '2023-01-19T18:19:42.728Z'
      },
      {
        name: 'Try it yourself',
        htmlTitle: '<p>Try it yourself</p>',
        type: '10',
        flair: {
          enabled: [],
          rating: 0,
          check: false,
          progress: 0,
          likely: [0, 0]
        },
        lastModified: '2023-01-27T16:01:24.033Z',
        children: [
          {
            name: 'Here is a little sandbox area for you. Try making a few notes. Go nuts!',
            htmlTitle:
              '<p>Here is a little sandbox area for you. Try making a few notes. Go nuts!</p>',
            type: 12,
            flair: {
              likely: [0, 0],
              enabled: [],
              check: false,
              rating: 0,
              progress: 0
            },
            lastModified: '2023-01-30T17:24:39.851Z'
          },
          {
            name: '',
            htmlTitle: '',
            type: 0,
            flair: {
              enabled: [],
              likely: [0, 0],
              progress: 0,
              rating: 0,
              check: false
            },
            lastModified: '2023-01-27T16:01:23.828Z'
          }
        ]
      },
      {
        name: "Let's look at some examples of the kind of structures we end up building!",
        htmlTitle:
          "<p>Let's look at some examples of the kind of structures we end up building!</p>",
        type: 3,
        flair: {
          enabled: [],
          rating: 0,
          likely: [0, 0],
          progress: 0,
          check: false
        },
        lastModified: '2023-01-19T18:20:02.990Z'
      },
      {
        name: 'Examples',
        htmlTitle: '<p>Examples</p>',
        type: 10,
        flair: {
          check: false,
          progress: 0,
          rating: 0,
          enabled: [],
          likely: [0, 0]
        },
        lastModified: '2023-01-31T19:02:28.419Z',
        children: [
          {
            name: 'Figuring out my busy weekend.',
            htmlTitle: '<p>Figuring out my busy weekend.</p>',
            type: '8',
            flair: {
              check: false,
              enabled: [],
              progress: 0,
              likely: [0, 0],
              rating: 0
            },
            lastModified: '2023-01-30T15:49:48.334Z',
            children: [
              {
                name:
                  "Side note - Here I just wanted to get straight what I needed to keep track of this weekend. It was feeling a bit hectic and I wanted to make sure I had it all worked out so I wouldn't miss anything.",
                htmlTitle:
                  "<p>Side note - Here I just wanted to get straight what I needed to keep track of this weekend. It was feeling a bit hectic and I wanted to make sure I had it all worked out so I wouldn't miss anything.</p>",
                type: '12',
                flair: {
                  check: false,
                  rating: 0,
                  likely: [0, 0],
                  enabled: [],
                  state: 1,
                  progress: 0
                },
                lastModified: '2023-01-19T18:28:48.168Z'
              },
              {
                name: 'Friday',
                htmlTitle: '<p>Friday</p>',
                type: '10',
                flair: {
                  rating: 0,
                  likely: [0, 0],
                  check: false,
                  enabled: [],
                  progress: 0
                },
                lastModified: '2022-12-16T14:19:07.194Z',
                children: [
                  {
                    name: "Watching friend's dog - don't forget",
                    htmlTitle: "<p>Watching friend's dog - don't forget</p>",
                    type: '2',
                    flair: {
                      likely: [0, 0],
                      rating: 0,
                      check: false,
                      enabled: [],
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:54:05.960Z'
                  },
                  {
                    name: 'Put out lights @5pm',
                    htmlTitle: '<p>Put out lights @5pm</p>',
                    type: '6',
                    flair: {
                      rating: 0,
                      progress: 0,
                      likely: [0, 0],
                      check: false,
                      enabled: []
                    },
                    lastModified: '2022-12-16T14:17:14.440Z',
                    children: [
                      {
                        name: 'Might need to do this a little early',
                        htmlTitle: '<p>Might need to do this a little early</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          progress: 0,
                          enabled: [],
                          check: false,
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-16T14:17:20.051Z'
                      }
                    ]
                  },
                  {
                    name: "Go to kid's school for art show - @5pm (right after putting out lights)",
                    htmlTitle:
                      "<p>Go to kid's school for art show - @5pm (right after putting out lights)</p>",
                    type: '6',
                    flair: {
                      rating: 0,
                      check: false,
                      likely: [0, 0],
                      enabled: [],
                      progress: 0
                    },
                    lastModified: '2022-12-16T14:18:59.754Z',
                    children: [
                      {
                        name: 'Give dog a treat or something.',
                        htmlTitle: '<p>Give dog a treat or something.</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          progress: 0,
                          likely: [0, 0],
                          check: false,
                          rating: 0
                        },
                        lastModified: '2022-12-16T14:17:54.580Z'
                      },
                      {
                        name:
                          'Make sure there is no food left around, or kids toys he might destroy',
                        htmlTitle:
                          '<p>Make sure there is no food left around, or kids toys he might destroy</p>',
                        type: 0,
                        flair: {
                          check: false,
                          rating: 0,
                          enabled: [],
                          likely: [0, 0],
                          progress: 0
                        },
                        lastModified: '2022-12-16T14:18:23.421Z'
                      },
                      {
                        name: 'Do we need to block off some rooms?',
                        htmlTitle: '<p>Do we need to block off some rooms?</p>',
                        type: '1',
                        flair: {
                          enabled: [],
                          likely: [0, 0],
                          rating: 0,
                          check: false,
                          progress: 0
                        },
                        lastModified: '2022-12-16T14:18:58.163Z'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'Saturday',
                htmlTitle: '<p>Saturday</p>',
                type: '10',
                flair: {
                  likely: [0, 0],
                  enabled: [],
                  rating: 0,
                  check: false,
                  progress: 0
                },
                lastModified: '2022-12-16T14:20:44.413Z',
                children: [
                  {
                    name: 'Holiday train! @8:45',
                    htmlTitle: '<p>Holiday train! @8:45</p>',
                    type: '6',
                    flair: {
                      likely: [0, 0],
                      enabled: [],
                      progress: 0,
                      rating: 0,
                      check: false
                    },
                    lastModified: '2022-12-16T14:22:30.378Z',
                    children: [
                      {
                        name: 'Leave by 8:15',
                        htmlTitle: '<p>Leave by 8:15</p>',
                        type: '2',
                        flair: {
                          likely: [0, 0],
                          rating: 0,
                          check: false,
                          enabled: [],
                          progress: 0
                        },
                        lastModified: '2022-12-16T14:21:06.620Z'
                      },
                      {
                        name: 'Make sure dog is taken care of - give special treat',
                        htmlTitle: '<p>Make sure dog is taken care of - give special treat</p>',
                        type: '0',
                        flair: {
                          check: false,
                          likely: [0, 0],
                          rating: 0,
                          progress: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-16T14:22:43.941Z'
                      }
                    ]
                  },
                  {
                    name: 'Make pizzelles',
                    htmlTitle: '<p>Make pizzelles</p>',
                    type: '6',
                    flair: {
                      progress: 0,
                      enabled: [],
                      check: false,
                      rating: 0,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-16T14:21:59.823Z',
                    children: [
                      {
                        name: 'https://www.culinaryhill.com/pizzelle-italian-cookies/',
                        htmlTitle:
                          '<p><a href="https://www.culinaryhill.com/pizzelle-italian-cookies/" target="_blank">https://www.culinaryhill.com/pizzelle-italian-cookies/</a></p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          check: false,
                          progress: 0,
                          enabled: [],
                          rating: 0
                        },
                        lastModified: '2022-12-16T14:20:03.099Z'
                      },
                      {
                        name: 'Need to make a batch without egg',
                        htmlTitle: '<p>Need to make a batch without egg</p>',
                        type: 2,
                        flair: {
                          progress: 0,
                          rating: 0,
                          check: false,
                          enabled: [],
                          likely: [0, 0]
                        },
                        lastModified: '2023-01-19T18:22:59.400Z'
                      },
                      {
                        name: 'Maybe try interesting shapes, like straws?',
                        htmlTitle: '<p>Maybe try interesting shapes, like straws?</p>',
                        type: '3',
                        flair: {
                          progress: 0,
                          rating: 0,
                          check: false,
                          enabled: [],
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-16T14:21:59.161Z'
                      },
                      {
                        name: 'Maybe try dipping in chocolate',
                        htmlTitle: '<p>Maybe try dipping in chocolate</p>',
                        type: '3',
                        flair: {
                          progress: 0,
                          rating: 0,
                          enabled: [],
                          likely: [0, 0],
                          check: false
                        },
                        lastModified: '2022-12-16T14:22:05.253Z'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'Sunday',
                htmlTitle: '<p>Sunday</p>',
                type: '10',
                flair: {
                  likely: [0, 0],
                  check: false,
                  progress: 0,
                  enabled: [],
                  rating: 0
                },
                lastModified: '2022-12-16T14:23:52.719Z',
                children: [
                  {
                    name: 'Tidy the house up',
                    htmlTitle: '<p>Tidy the house up</p>',
                    type: '6',
                    flair: {
                      rating: 0,
                      progress: 0,
                      check: false,
                      enabled: [],
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-16T14:22:22.845Z'
                  },
                  {
                    name: 'Try out new ripping chain on chainsaw if have not yet',
                    htmlTitle: '<p>Try out new ripping chain on chainsaw if have not yet</p>',
                    type: '6',
                    flair: {
                      rating: 0,
                      progress: 0,
                      likely: [0, 0],
                      check: false,
                      enabled: []
                    },
                    lastModified: '2022-12-16T14:23:19.667Z'
                  },
                  {
                    name: 'Make progress on yard projects',
                    htmlTitle: '<p>Make progress on yard projects</p>',
                    type: '6',
                    flair: {
                      progress: 0,
                      likely: [0, 0],
                      rating: 0,
                      check: false,
                      enabled: []
                    },
                    lastModified: '2022-12-16T14:23:58.174Z'
                  }
                ]
              }
            ]
          },
          {
            name: 'Organizing my Digital Wall Calendar project, and figuring out a plan.',
            htmlTitle:
              '<p>Organizing my Digital Wall Calendar project, and figuring out a plan.</p>',
            type: 8,
            flair: {
              likely: [0, 0],
              enabled: [],
              check: false,
              rating: 0,
              progress: 0
            },
            lastModified: '2023-01-30T15:49:48.941Z',
            children: [
              {
                name:
                  "Side note - I wanted to build a digital wall calendar so my family could see everyone's schedule while in the kitchen. There were a lot of different ways to go about it, so I wanted to keep everything in one place, but clear and organized, so it was easy to see where I was and what I needed to do next.",
                htmlTitle:
                  "<p>Side note - I wanted to build a digital wall calendar so my family could see everyone's schedule while in the kitchen. There were a lot of different ways to go about it, so I wanted to keep everything in one place, but clear and organized, so it was easy to see where I was and what I needed to do next.</p>",
                type: '12',
                flair: {
                  progress: 0,
                  check: false,
                  likely: [0, 0],
                  enabled: [],
                  rating: 0,
                  state: 1
                },
                lastModified: '2023-01-19T18:29:13.281Z'
              },
              {
                name: 'Mini plan',
                htmlTitle: '<p>Mini plan</p>',
                type: '10',
                flair: {
                  enabled: [],
                  check: false,
                  progress: 0,
                  likely: [0, 0],
                  rating: 0
                },
                lastModified: '2022-12-19T15:31:10.807Z',
                children: [
                  {
                    name: 'Buy parts',
                    htmlTitle: '<p>Buy parts</p>',
                    type: 0,
                    flair: {
                      rating: 0,
                      progress: 0,
                      check: false,
                      enabled: [],
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T15:31:10.686Z'
                  },
                  {
                    name: 'Test Raspberry pi on any monitor',
                    htmlTitle: '<p>Test Raspberry pi on any monitor</p>',
                    type: 0,
                    flair: {
                      likely: [0, 0],
                      rating: 0,
                      check: false,
                      progress: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T15:31:10.686Z'
                  },
                  {
                    name: 'Build a wood frame for monitor',
                    htmlTitle: '<p>Build a wood frame for monitor</p>',
                    type: 0,
                    flair: {
                      enabled: [],
                      likely: [0, 0],
                      check: false,
                      rating: 0,
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.685Z'
                  },
                  {
                    name: 'Mount using picture wire',
                    htmlTitle: '<p>Mount using picture wire</p>',
                    type: 0,
                    flair: {
                      check: false,
                      likely: [0, 0],
                      progress: 0,
                      rating: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T15:31:10.685Z'
                  }
                ]
              },
              {
                name: 'Parts to buy',
                htmlTitle: '<p>Parts to buy</p>',
                type: 10,
                flair: {
                  enabled: [],
                  likely: [0, 0],
                  check: false,
                  progress: 0,
                  rating: 0
                },
                lastModified: '2022-12-19T15:31:10.807Z',
                children: [
                  {
                    name: 'Dell 24 Monitor - S2421H',
                    htmlTitle: '<p>Dell 24 Monitor - S2421H</p>',
                    type: 6,
                    flair: {
                      check: false,
                      likely: [0, 0],
                      enabled: [],
                      progress: 0,
                      rating: 0
                    },
                    lastModified: '2022-12-19T15:31:10.685Z'
                  },
                  {
                    name: 'Short HDMI cable',
                    htmlTitle: '<p>Short HDMI cable</p>',
                    type: 6,
                    flair: {
                      rating: 0,
                      check: false,
                      likely: [0, 0],
                      enabled: [],
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.684Z'
                  },
                  {
                    name: 'Raspberry pi 3+',
                    htmlTitle: '<p>Raspberry pi 3+</p>',
                    type: 6,
                    flair: {
                      rating: 0,
                      likely: [0, 0],
                      enabled: [],
                      check: false,
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.685Z'
                  },
                  {
                    name: 'Memory chip',
                    htmlTitle: '<p>Memory chip</p>',
                    type: 6,
                    flair: {
                      progress: 0,
                      rating: 0,
                      enabled: [],
                      check: false,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T15:31:10.685Z'
                  }
                ]
              },
              {
                name: 'Info',
                htmlTitle: '<p>Info</p>',
                type: 7,
                flair: {
                  progress: 0,
                  rating: 0,
                  check: false,
                  enabled: [],
                  likely: [0, 0]
                },
                lastModified: '2022-12-19T15:31:10.807Z',
                children: [
                  {
                    name: 'Wall is 22" wide - this needs to include the frame',
                    htmlTitle: '<p>Wall is 22" wide - this needs to include the frame</p>',
                    type: 0,
                    flair: {
                      check: false,
                      enabled: [],
                      rating: 0,
                      progress: 0,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T15:31:10.686Z'
                  },
                  {
                    name: 'Reddit post',
                    htmlTitle:
                      '<p><a href="https://www.reddit.com/r/smarthome/comments/n7afta/best_way_to_display_google_calendar_on_kitchen/" target="_blank">Reddit post</a></p>',
                    type: 0,
                    flair: {
                      progress: 0,
                      rating: 0,
                      enabled: [],
                      check: false,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T15:31:10.686Z'
                  },
                  {
                    name: 'DAKboard',
                    htmlTitle:
                      '<p><a href="https://shop.dakboard.com/collections/wall-displays" target="_blank">DAKboard</a></p>',
                    type: 0,
                    flair: {
                      enabled: [],
                      check: false,
                      likely: [0, 0],
                      rating: 0,
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.687Z'
                  },
                  {
                    name: 'Cool Etsy project $900',
                    htmlTitle:
                      '<p><a href="https://www.etsy.com/listing/685453312/24-digital-wall-display-smart-screen?gpla=1&amp;gao=1&amp;&amp;utm_source=google&amp;utm_medium=cpc&amp;utm_campaign=shopping_us_ps-a-electronics_and_accessories-computers_and_peripherals-computers&amp;utm_custom1=_k_Cj0KCQjw166aBhDEARIsAMEyZh4MrnBBS7qtC55trorlJmdElg07VO51Ewiap4j_qc_mjskksmINJXQaApcvEALw_wcB_k_&amp;utm_content=go_12566250689_114687951570_507300502079_aud-1408996296175:pla-353923937411_c__685453312_110735879&amp;utm_custom2=12566250689&amp;gclid=Cj0KCQjw166aBhDEARIsAMEyZh4MrnBBS7qtC55trorlJmdElg07VO51Ewiap4j_qc_mjskksmINJXQaApcvEALw_wcB" target="_blank">Cool Etsy project $900</a></p>',
                    type: 0,
                    flair: {
                      progress: 0,
                      enabled: [],
                      likely: [0, 0],
                      check: false,
                      rating: 0
                    },
                    lastModified: '2022-12-19T15:31:10.687Z'
                  },
                  {
                    name: 'Raspberry Pi DIY',
                    htmlTitle:
                      '<p><a href="https://blog.dakboard.com/diy-wall-display/" target="_blank">Raspberry Pi DIY</a></p>',
                    type: 0,
                    flair: {
                      likely: [0, 0],
                      progress: 0,
                      check: false,
                      rating: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T15:31:10.687Z'
                  }
                ]
              }
            ]
          },
          {
            name: 'Make progress on my blog article "How is Context Different".',
            htmlTitle: '<p>Make progress on my blog article "How is Context Different".</p>',
            type: 8,
            flair: {
              rating: 0,
              check: false,
              progress: 0,
              enabled: [],
              likely: [0, 0]
            },
            lastModified: '2023-01-30T15:49:49.387Z',
            children: [
              {
                name:
                  "Side note - I was thinking in the shower about how I often get asked what makes Context different, and I wasn't happy with my answer. I thought writing an article would be a good way to get my thoughts straight. I used Context to organize my ideas, articulate my concerns and purpose and work through different outlines.",
                htmlTitle:
                  "<p>Side note - I was thinking in the shower about how I often get asked what makes Context different, and I wasn't happy with my answer. I thought writing an article would be a good way to get my thoughts straight. I used Context to organize my ideas, articulate my concerns and purpose and work through different outlines.</p>",
                type: '12',
                flair: {
                  enabled: [],
                  check: false,
                  rating: 0,
                  likely: [0, 0],
                  progress: 0,
                  state: 1
                },
                lastModified: '2023-01-19T18:28:20.960Z'
              },
              {
                name: 'Article framing',
                htmlTitle: '<p>Article framing</p>',
                type: '10',
                flair: {
                  progress: 0,
                  rating: 0,
                  likely: [0, 0],
                  check: false,
                  enabled: []
                },
                lastModified: '2022-12-19T15:31:10.906Z',
                children: [
                  {
                    name: "Goal: Communicate what's different about Context vs. other similar apps",
                    htmlTitle:
                      "<p><strong>Goal</strong>: Communicate what's different about Context vs. other similar apps</p>",
                    type: 0,
                    flair: {
                      rating: 0,
                      likely: [0, 0],
                      enabled: [],
                      progress: 0,
                      state: null,
                      check: false
                    },
                    lastModified: '2022-12-19T15:34:48.905Z'
                  },
                  {
                    name: "The style we've been using",
                    htmlTitle: "<p>The style we've been using</p>",
                    type: 8,
                    flair: {
                      rating: 0,
                      likely: [0, 0],
                      check: false,
                      progress: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T15:31:10.809Z',
                    children: [
                      {
                        name:
                          "Light, conversational, (like we're giving a talk to a small roomful of people)",
                        htmlTitle:
                          "<p>Light, conversational, (like we're giving a talk to a small roomful of people)</p>",
                        type: 0,
                        flair: {
                          rating: 0,
                          progress: 0,
                          enabled: [],
                          likely: [0, 0],
                          check: false
                        },
                        lastModified: '2022-12-19T15:31:10.694Z'
                      },
                      {
                        name: 'First person',
                        htmlTitle: '<p>First person</p>',
                        type: 0,
                        flair: {
                          check: false,
                          enabled: [],
                          progress: 0,
                          likely: [0, 0],
                          rating: 0
                        },
                        lastModified: '2022-12-19T15:31:10.694Z'
                      },
                      {
                        name: 'Tell a story, make it real, specific, tangible',
                        htmlTitle: '<p>Tell a story, make it real, specific, tangible</p>',
                        type: 0,
                        flair: {
                          progress: 0,
                          enabled: [],
                          likely: [0, 0],
                          rating: 0,
                          check: false
                        },
                        lastModified: '2022-12-19T15:31:10.694Z'
                      },
                      {
                        name: 'Typically section headers tell a story',
                        htmlTitle: '<p>Typically section headers tell a story</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          progress: 0,
                          rating: 0,
                          enabled: [],
                          check: false
                        },
                        lastModified: '2022-12-19T15:31:10.694Z'
                      }
                    ]
                  },
                  {
                    name: 'Main points I want to get across',
                    htmlTitle: '<p>Main points I want to get across</p>',
                    type: 8,
                    flair: {
                      check: false,
                      likely: [0, 0],
                      enabled: [],
                      rating: 0,
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.810Z',
                    children: [
                      {
                        name:
                          'As a result of the fact that I have a place and tool to do this, it can collapse all the stuff I used to do everywhere ',
                        htmlTitle:
                          '<p>As a result of the fact that I have a place and tool to do this, it can collapse all the stuff I used to do everywhere </p>',
                        type: 4,
                        flair: {
                          progress: 0,
                          enabled: [],
                          rating: 0,
                          likely: [0, 0],
                          check: false
                        },
                        lastModified: '2022-12-19T15:34:17.124Z'
                      },
                      {
                        name: 'Our Job is a thinking tool',
                        htmlTitle: '<p>Our Job is a thinking tool</p>',
                        type: 4,
                        flair: {
                          enabled: [],
                          progress: 0,
                          check: false,
                          rating: 0,
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T15:34:17.124Z'
                      },
                      {
                        name: 'Contrast this to the different types of apps ',
                        htmlTitle: '<p>Contrast this to the different types of apps </p>',
                        type: 4,
                        flair: {
                          progress: 0,
                          check: false,
                          rating: 0,
                          enabled: [],
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T15:34:17.124Z'
                      }
                    ]
                  },
                  {
                    name: 'Questions to ask myself',
                    htmlTitle: '<p>Questions to ask myself</p>',
                    type: 8,
                    flair: {
                      rating: 0,
                      enabled: [],
                      progress: 0,
                      likely: [0, 0],
                      check: false
                    },
                    lastModified: '2022-12-19T15:31:10.810Z',
                    children: [
                      {
                        name: 'What is the article about and what is the title?',
                        htmlTitle: '<p>What is the article about and what is the title?</p>',
                        type: 1,
                        flair: {
                          enabled: [],
                          check: false,
                          likely: [0, 0],
                          rating: 0,
                          progress: 0
                        },
                        lastModified: '2022-12-19T15:34:11.548Z'
                      },
                      {
                        name:
                          'If I say the beats out loud, do they make sense and are they compelling?  Are they interesting?',
                        htmlTitle:
                          '<p>If I say the beats out loud, do they make sense and are they compelling?  Are they interesting?</p>',
                        type: 1,
                        flair: {
                          rating: 0,
                          check: false,
                          enabled: [],
                          likely: [0, 0],
                          progress: 0
                        },
                        lastModified: '2022-12-19T15:34:11.549Z'
                      },
                      {
                        name:
                          "Is it clear why I'm writing the article and what the reader will get out of it right up front?",
                        htmlTitle:
                          "<p>Is it clear why I'm writing the article and what the reader will get out of it right up front?</p>",
                        type: 1,
                        flair: {
                          enabled: [],
                          rating: 0,
                          likely: [0, 0],
                          check: false,
                          progress: 0
                        },
                        lastModified: '2022-12-19T15:34:11.549Z'
                      },
                      {
                        name:
                          "The first paragraph - does it set the stage? Seem engaging? Tell the reader what's coming?",
                        htmlTitle:
                          "<p>The first paragraph - does it set the stage? Seem engaging? Tell the reader what's coming?</p>",
                        type: 1,
                        flair: {
                          check: false,
                          progress: 0,
                          likely: [0, 0],
                          rating: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T15:34:11.549Z'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'Outline 2',
                htmlTitle: '<p>Outline 2</p>',
                type: '8',
                flair: {
                  enabled: [],
                  check: false,
                  likely: [0, 0],
                  progress: 0,
                  rating: 0
                },
                lastModified: '2022-12-19T15:31:10.906Z',
                children: [
                  {
                    name:
                      'I get asked a lot "how is context different from every other notes app?"',
                    htmlTitle:
                      '<p>I get asked a lot "how is context different from every other notes app?"</p>',
                    type: 0,
                    flair: {
                      likely: [0, 0],
                      enabled: [],
                      rating: 0,
                      progress: 0,
                      check: false
                    },
                    lastModified: '2022-12-19T15:31:10.691Z'
                  },
                  {
                    name: 'Context is for figuring things out',
                    htmlTitle: '<p>Context is for figuring things out</p>',
                    type: 0,
                    flair: {
                      check: false,
                      enabled: [],
                      progress: 0,
                      rating: 0,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T15:31:10.692Z'
                  },
                  {
                    name: 'OneNote, Evernote and Apple Notes',
                    htmlTitle: '<p>OneNote, Evernote and Apple Notes</p>',
                    type: 0,
                    flair: {
                      enabled: [],
                      likely: [0, 0],
                      progress: 0,
                      rating: 0,
                      check: false
                    },
                    lastModified: '2022-12-19T15:31:10.809Z',
                    children: [
                      {
                        name: 'Good for capture and store',
                        htmlTitle: '<p>Good for capture and store</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          check: false,
                          progress: 0,
                          enabled: [],
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T15:31:10.693Z'
                      },
                      {
                        name: 'Bad for developing ideas',
                        htmlTitle: '<p>Bad for developing ideas</p>',
                        type: 0,
                        flair: {
                          check: false,
                          rating: 0,
                          progress: 0,
                          likely: [0, 0],
                          enabled: []
                        },
                        lastModified: '2022-12-19T15:31:10.693Z'
                      }
                    ]
                  },
                  {
                    name: 'Obsidian and Roam',
                    htmlTitle: '<p>Obsidian and Roam</p>',
                    type: 0,
                    flair: {
                      check: false,
                      rating: 0,
                      enabled: [],
                      likely: [0, 0],
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.809Z',
                    children: [
                      {
                        name: 'Good for organizing research',
                        htmlTitle: '<p>Good for organizing research</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          check: false,
                          rating: 0,
                          likely: [0, 0],
                          progress: 0
                        },
                        lastModified: '2022-12-19T15:31:10.692Z'
                      },
                      {
                        name: 'Bad for figuring out',
                        htmlTitle: '<p>Bad for figuring out</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          rating: 0,
                          likely: [0, 0],
                          progress: 0,
                          check: false
                        },
                        lastModified: '2022-12-19T15:31:10.692Z'
                      }
                    ]
                  },
                  {
                    name: 'Google Docs, Word, Coda and Notion',
                    htmlTitle: '<p>Google Docs, Word, Coda and Notion</p>',
                    type: 0,
                    flair: {
                      enabled: [],
                      likely: [0, 0],
                      rating: 0,
                      check: false,
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.809Z',
                    children: [
                      {
                        name: 'Good for final documents',
                        htmlTitle: '<p>Good for final documents</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          likely: [0, 0],
                          progress: 0,
                          check: false,
                          rating: 0
                        },
                        lastModified: '2022-12-19T15:31:10.692Z'
                      },
                      {
                        name: 'Bad for organization',
                        htmlTitle: '<p>Bad for organization</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          progress: 0,
                          rating: 0,
                          check: false,
                          enabled: []
                        },
                        lastModified: '2022-12-19T15:31:10.692Z'
                      }
                    ]
                  },
                  {
                    name: 'Context',
                    htmlTitle: '<p>Context</p>',
                    type: 0,
                    flair: {
                      check: false,
                      rating: 0,
                      enabled: [],
                      likely: [0, 0],
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.809Z',
                    children: [
                      {
                        name: 'Good for getting things down and working through them',
                        htmlTitle: '<p>Good for getting things down and working through them</p>',
                        type: 0,
                        flair: {
                          check: false,
                          likely: [0, 0],
                          enabled: [],
                          rating: 0,
                          progress: 0
                        },
                        lastModified: '2022-12-19T15:31:10.691Z'
                      },
                      {
                        name: 'Thinking tool',
                        htmlTitle: '<p>Thinking tool</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          enabled: [],
                          check: false,
                          progress: 0,
                          rating: 0
                        },
                        lastModified: '2022-12-19T15:31:10.691Z'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'Outline 1',
                htmlTitle: '<p>Outline 1</p>',
                type: '8',
                flair: {
                  check: false,
                  likely: [0, 0],
                  rating: 0,
                  progress: 0,
                  enabled: []
                },
                lastModified: '2022-12-19T15:31:10.906Z',
                children: [
                  {
                    name: 'Notes and tasks apps have various jobs you hire them to do.  ',
                    htmlTitle:
                      '<p>Notes and tasks apps have various jobs you hire them to do.  </p>',
                    type: 0,
                    flair: {
                      check: false,
                      progress: 0,
                      enabled: [],
                      rating: 0,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T15:31:10.808Z',
                    children: [
                      {
                        name:
                          "Let's compare the different apps out by looking at what their purpose is",
                        htmlTitle:
                          "<p>Let's compare the different apps out by looking at what their purpose is</p>",
                        type: 0,
                        flair: {
                          progress: 0,
                          likely: [0, 0],
                          enabled: [],
                          check: false,
                          rating: 0
                        },
                        lastModified: '2022-12-19T15:31:10.690Z'
                      }
                    ]
                  },
                  {
                    name: 'Capture and store information for later',
                    htmlTitle: '<p>Capture and store information for later</p>',
                    type: 0,
                    flair: {
                      rating: 0,
                      likely: [0, 0],
                      check: false,
                      progress: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T15:31:10.690Z'
                  },
                  {
                    name: 'Organize my research',
                    htmlTitle: '<p>Organize my research</p>',
                    type: 0,
                    flair: {
                      likely: [0, 0],
                      check: false,
                      enabled: [],
                      rating: 0,
                      progress: 0
                    },
                    lastModified: '2022-12-19T15:31:10.690Z'
                  },
                  {
                    name: 'Create a document',
                    htmlTitle: '<p>Create a document</p>',
                    type: 0,
                    flair: {
                      check: false,
                      enabled: [],
                      progress: 0,
                      likely: [0, 0],
                      rating: 0
                    },
                    lastModified: '2022-12-19T15:31:10.689Z'
                  },
                  {
                    name: 'Work on thinky stuff',
                    htmlTitle: '<p>Work on thinky stuff</p>',
                    type: 0,
                    flair: {
                      likely: [0, 0],
                      progress: 0,
                      rating: 0,
                      check: false,
                      enabled: []
                    },
                    lastModified: '2022-12-19T15:31:10.690Z'
                  },
                  {
                    name: 'Summary: Context is a thinking tool.  ',
                    htmlTitle: '<p>Summary: Context is a thinking tool.  </p>',
                    type: 0,
                    flair: {
                      progress: 0,
                      enabled: [],
                      likely: [0, 0],
                      check: false,
                      rating: 0
                    },
                    lastModified: '2022-12-19T15:31:10.691Z'
                  }
                ]
              },
              {
                name: 'Notes/Ideas',
                htmlTitle: '<p>Notes/Ideas</p>',
                type: 7,
                flair: {
                  enabled: [],
                  rating: 0,
                  progress: 0,
                  likely: [0, 0],
                  check: false
                },
                lastModified: '2022-12-19T15:31:10.907Z',
                children: [
                  {
                    name: 'Different mechanisms',
                    htmlTitle: '<p>Different mechanisms</p>',
                    type: 8,
                    flair: {
                      check: false,
                      progress: 0,
                      enabled: [],
                      likely: [0, 0],
                      rating: 0
                    },
                    lastModified: '2022-12-19T16:43:34.627Z',
                    children: [
                      {
                        name: 'Mini doc - dumping ground',
                        htmlTitle: '<p>Mini doc - dumping ground</p>',
                        type: 3,
                        flair: {
                          rating: 0,
                          enabled: [],
                          progress: 0,
                          check: false,
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T16:43:37.395Z'
                      },
                      {
                        name: 'PKM/Networked notes - good for research',
                        htmlTitle: '<p>PKM/Networked notes - good for research</p>',
                        type: 3,
                        flair: {
                          rating: 0,
                          check: false,
                          progress: 0,
                          likely: [0, 0],
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:43:37.395Z'
                      },
                      {
                        name: 'Notion/Word, docs & super docs - coda/gitbook/air table',
                        htmlTitle:
                          '<p>Notion/Word, docs &amp; super docs - coda/gitbook/air table</p>',
                        type: 3,
                        flair: {
                          rating: 0,
                          check: false,
                          enabled: [],
                          likely: [0, 0],
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:43:37.395Z'
                      }
                    ]
                  },
                  {
                    name: 'Use cases',
                    htmlTitle: '<p>Use cases</p>',
                    type: 8,
                    flair: {
                      rating: 0,
                      check: false,
                      likely: [0, 0],
                      progress: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T16:43:32.700Z',
                    children: [
                      {
                        name: 'Research/second brain/organize all your knowledge on a subject',
                        htmlTitle:
                          '<p>Research/second brain/organize all your knowledge on a subject</p>',
                        type: 3,
                        flair: {
                          progress: 0,
                          likely: [0, 0],
                          check: false,
                          rating: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:43:39.987Z'
                      },
                      {
                        name: 'Just quickly record a thought/notes so I can find it later',
                        htmlTitle:
                          '<p>Just quickly record a thought/notes so I can find it later</p>',
                        type: 3,
                        flair: {
                          likely: [0, 0],
                          check: false,
                          rating: 0,
                          enabled: [],
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:43:39.987Z'
                      },
                      {
                        name:
                          "Document building/mini app/wiki to craft a nice looking document of what's important",
                        htmlTitle:
                          "<p>Document building/mini app/wiki to craft a nice looking document of what's important</p>",
                        type: 3,
                        flair: {
                          check: false,
                          rating: 0,
                          likely: [0, 0],
                          enabled: [],
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:43:39.987Z'
                      },
                      {
                        name: 'Thinking tool - figuring out, organizing and prioritizing thought',
                        htmlTitle:
                          '<p>Thinking tool - figuring out, organizing and prioritizing thought</p>',
                        type: 3,
                        flair: {
                          rating: 0,
                          likely: [0, 0],
                          progress: 0,
                          check: false,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:43:39.987Z'
                      },
                      {
                        name: 'Just tasks - keep track, assign, date',
                        htmlTitle: '<p>Just tasks - keep track, assign, date</p>',
                        type: 3,
                        flair: {
                          enabled: [],
                          progress: 0,
                          check: false,
                          likely: [0, 0],
                          rating: 0
                        },
                        lastModified: '2022-12-19T16:43:39.987Z'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            name: 'Work through a new software feature.',
            htmlTitle: '<p>Work through a new software feature.</p>',
            type: 8,
            flair: {
              enabled: [],
              progress: 0,
              rating: 0,
              check: false,
              likely: [0, 0]
            },
            lastModified: '2023-01-30T15:49:50.358Z',
            children: [
              {
                name: 'To Dos',
                htmlTitle: '<p>To Dos</p>',
                type: '10',
                flair: {
                  enabled: [],
                  check: false,
                  rating: 0,
                  progress: 0,
                  likely: [0, 0]
                },
                lastModified: '2022-12-19T16:31:07.132Z',
                children: [
                  {
                    name: 'Make the quick search clearable',
                    htmlTitle: '<p>Make the quick search clearable</p>',
                    type: 6,
                    flair: {
                      progress: 0,
                      likely: [0, 0],
                      enabled: [],
                      rating: 0,
                      check: false
                    },
                    lastModified: '2022-12-19T16:30:43.262Z'
                  },
                  {
                    name: 'Large paragraphs search results need to be trimmed',
                    htmlTitle: '<p>Large paragraphs search results need to be trimmed</p>',
                    type: 6,
                    flair: {
                      likely: [0, 0],
                      progress: 0,
                      check: false,
                      rating: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T16:31:10.414Z'
                  }
                ]
              },
              {
                name: 'Notes',
                htmlTitle: '<p>Notes</p>',
                type: '10',
                flair: {
                  rating: 0,
                  enabled: [],
                  check: false,
                  likely: [0, 0],
                  progress: 0
                },
                lastModified: '2022-12-19T16:30:30.242Z',
                children: [
                  {
                    name: 'Ways to improve search 3/3/322',
                    htmlTitle: '<p>Ways to improve search 3/3/322</p>',
                    type: 8,
                    flair: {
                      progress: 0,
                      likely: [0, 0],
                      enabled: [],
                      rating: 0,
                      check: false
                    },
                    lastModified: '2022-12-19T16:37:57.765Z',
                    children: [
                      {
                        name: 'Large paragraphs search results need to be trimmed',
                        htmlTitle: '<p>Large paragraphs search results need to be trimmed</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          rating: 0,
                          enabled: [],
                          check: false,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:30:29.936Z'
                      },
                      {
                        name: 'Distinguish between cards vs. outline',
                        htmlTitle: '<p>Distinguish between cards vs. outline</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          rating: 0,
                          check: false,
                          enabled: [],
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:30:29.937Z'
                      },
                      {
                        name:
                          'Search should open and highlight the bullets that are found within the outline',
                        htmlTitle:
                          '<p>Search should open and highlight the bullets that are found within the outline</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          rating: 0,
                          check: false,
                          progress: 0,
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T16:30:29.937Z'
                      },
                      {
                        name: 'Clear x button',
                        htmlTitle: '<p>Clear x button</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          check: false,
                          progress: 0,
                          likely: [0, 0],
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:30:29.937Z'
                      },
                      {
                        name: 'Clicking anywhere in the card should open the archived card',
                        htmlTitle:
                          '<p>Clicking anywhere in the card should open the archived card</p>',
                        type: 0,
                        flair: {
                          progress: 0,
                          check: false,
                          likely: [0, 0],
                          rating: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:30:29.937Z'
                      },
                      {
                        name: 'Find within open window',
                        htmlTitle: '<p>Find within open window</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          rating: 0,
                          check: false,
                          likely: [0, 0],
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:30:30.025Z',
                        children: [
                          {
                            name: 'acts like chrome search but opens closed bullets',
                            htmlTitle: '<p>acts like chrome search but opens closed bullets</p>',
                            type: 0,
                            flair: {
                              check: false,
                              rating: 0,
                              enabled: [],
                              progress: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:30:29.936Z'
                          },
                          {
                            name:
                              'maybe it can remember the state of openness when ctrl-F is hit and when you cycle through the search hits, it will open, highlight and close automatically',
                            htmlTitle:
                              '<p>maybe it can remember the state of openness when ctrl-F is hit and when you cycle through the search hits, it will open, highlight and close automatically</p>',
                            type: 0,
                            flair: {
                              enabled: [],
                              check: false,
                              likely: [0, 0],
                              progress: 0,
                              rating: 0
                            },
                            lastModified: '2022-12-19T16:30:29.936Z'
                          }
                        ]
                      }
                    ]
                  },
                  {
                    name: 'How multiple domains work 3/1/22',
                    htmlTitle: '<p>How multiple domains work 3/1/22</p>',
                    type: 8,
                    flair: {
                      check: false,
                      progress: 0,
                      enabled: [],
                      rating: 0,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T16:37:53.744Z',
                    children: [
                      {
                        name: 'To get all the contexts(domains) of a user',
                        htmlTitle: '<p>To get all the contexts(domains) of a user</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          progress: 0,
                          enabled: [],
                          check: false,
                          rating: 0
                        },
                        lastModified: '2022-12-19T16:30:30.113Z',
                        children: [
                          {
                            name: 'Import the contextModule',
                            htmlTitle: '<p>Import the contextModule</p>',
                            type: 0,
                            flair: {
                              rating: 0,
                              likely: [0, 0],
                              enabled: [],
                              progress: 0,
                              check: false
                            },
                            lastModified: '2022-12-19T16:30:29.935Z'
                          },
                          {
                            name: 'Query the contextModule',
                            htmlTitle: '<p>Query the contextModule</p>',
                            type: 0,
                            flair: {
                              likely: [0, 0],
                              rating: 0,
                              enabled: [],
                              check: false,
                              progress: 0
                            },
                            lastModified: '2022-12-19T16:30:30.024Z',
                            children: [
                              {
                                name:
                                  'const domains = contextsModule.data.values().filter(c => c.version == 2);',
                                htmlTitle:
                                  '<p>const domains =&nbsp;contextsModule.data.values().filter(c =&gt; c.version == 2);</p>',
                                type: 0,
                                flair: {
                                  likely: [0, 0],
                                  enabled: [],
                                  progress: 0,
                                  check: false,
                                  rating: 0
                                },
                                lastModified: '2022-12-19T16:30:29.934Z'
                              },
                              {
                                name:
                                  'That will return all the contexts(domains) that the user has imported.',
                                htmlTitle:
                                  '<p>That will return all the contexts(domains) that the user has imported.</p>',
                                type: 0,
                                flair: {
                                  rating: 0,
                                  enabled: [],
                                  likely: [0, 0],
                                  progress: 0,
                                  check: false
                                },
                                lastModified: '2022-12-19T16:30:29.934Z'
                              }
                            ]
                          },
                          {
                            name: 'Then loop over those domains.forEach(domain => ...)',
                            htmlTitle:
                              '<p>Then loop over those domains.forEach(domain =&gt; ...)</p>',
                            type: 0,
                            flair: {
                              enabled: [],
                              rating: 0,
                              progress: 0,
                              likely: [0, 0],
                              check: false
                            },
                            lastModified: '2022-12-19T16:30:29.935Z'
                          },
                          {
                            name: 'domain.text == the name of the domain',
                            htmlTitle: '<p>domain.text == the name of the domain</p>',
                            type: 0,
                            flair: {
                              rating: 0,
                              enabled: [],
                              check: false,
                              progress: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:30:29.935Z'
                          },
                          {
                            name: 'domain.text.slice(0,1) gives ou the firsit letter',
                            htmlTitle: '<p>domain.text.slice(0,1) gives ou the firsit letter</p>',
                            type: 0,
                            flair: {
                              enabled: [],
                              check: false,
                              rating: 0,
                              progress: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:30:29.935Z'
                          },
                          {
                            name: 'domain.color == the color',
                            htmlTitle: '<p>domain.color == the color</p>',
                            type: 0,
                            flair: {
                              rating: 0,
                              check: false,
                              enabled: [],
                              progress: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:30:29.934Z'
                          },
                          {
                            name: 'domain.id == id',
                            htmlTitle: '<p>domain.id == id</p>',
                            type: 0,
                            flair: {
                              check: false,
                              rating: 0,
                              enabled: [],
                              likely: [0, 0],
                              progress: 0
                            },
                            lastModified: '2022-12-19T16:30:29.934Z'
                          }
                        ]
                      },
                      {
                        name: 'To get Active Domains',
                        htmlTitle: '<p>To get Active Domains</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          check: false,
                          enabled: [],
                          progress: 0,
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T16:30:30.024Z',
                        children: [
                          {
                            name: '',
                            htmlTitle: '',
                            type: 0,
                            flair: {
                              enabled: [],
                              likely: [0, 0],
                              check: false,
                              rating: 0,
                              progress: 0
                            },
                            lastModified: '2022-12-19T16:30:29.934Z'
                          }
                        ]
                      },
                      {
                        name: 'Look at the leftBar in the vue tool to see the megacontext objects',
                        htmlTitle:
                          '<p>Look at the leftBar in the vue tool to see the megacontext objects</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          rating: 0,
                          progress: 0,
                          check: false,
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T16:30:29.933Z'
                      },
                      {
                        name: 'Look at Outline (useOutline)',
                        htmlTitle: '<p>Look at Outline (useOutline)</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          likely: [0, 0],
                          progress: 0,
                          check: false,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:30:30.113Z',
                        children: [
                          {
                            name: 'vues/context/comopnetns/contentsectin/outline/useOuline',
                            htmlTitle:
                              '<p>vues/context/comopnetns/contentsectin/outline/useOuline</p>',
                            type: 0,
                            flair: {
                              enabled: [],
                              rating: 0,
                              progress: 0,
                              check: false,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:30:29.935Z'
                          },
                          {
                            name: 'in state, we have domains',
                            htmlTitle: '<p>in state, we have domains</p>',
                            type: 0,
                            flair: {
                              check: false,
                              likely: [0, 0],
                              progress: 0,
                              rating: 0,
                              enabled: []
                            },
                            lastModified: '2022-12-19T16:30:29.936Z'
                          },
                          {
                            name: 'Every time we open one, it gets added there',
                            htmlTitle: '<p>Every time we open one, it gets added there</p>',
                            type: 0,
                            flair: {
                              check: false,
                              progress: 0,
                              likely: [0, 0],
                              enabled: [],
                              rating: 0
                            },
                            lastModified: '2022-12-19T16:30:29.935Z'
                          },
                          {
                            name: 'that Id can  be put in to get all the panel/archive root ids',
                            htmlTitle:
                              '<p>that Id can  be put in to get all the panel/archive root ids</p>',
                            type: 0,
                            flair: {
                              check: false,
                              rating: 0,
                              likely: [0, 0],
                              enabled: [],
                              progress: 0
                            },
                            lastModified: '2022-12-19T16:30:30.024Z',
                            children: [
                              {
                                name:
                                  ' const contextId = useContext().activeContextId.value; const context = contextsModule.doc(contextId).data;',
                                htmlTitle:
                                  '<p>&nbsp;const contextId = useContext().activeContextId.value;</p><p>&nbsp;const context = contextsModule.doc(contextId).data;</p>',
                                type: 0,
                                flair: {
                                  progress: 0,
                                  enabled: [],
                                  rating: 0,
                                  likely: [0, 0],
                                  check: false
                                },
                                lastModified: '2022-12-19T16:30:29.936Z'
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                name: 'Old notes',
                htmlTitle: '<p>Old notes</p>',
                type: 7,
                flair: {
                  enabled: [],
                  check: false,
                  progress: 0,
                  rating: 0,
                  likely: [0, 0]
                },
                lastModified: '2022-12-19T16:37:01.246Z',
                children: [
                  {
                    name: 'How to hook up domains 2/28/22',
                    htmlTitle: '<p>How to hook up domains 2/28/22</p>',
                    type: 8,
                    flair: {
                      likely: [0, 0],
                      enabled: [],
                      rating: 0,
                      check: false,
                      progress: 0
                    },
                    lastModified: '2022-12-19T16:40:42.009Z',
                    children: [
                      {
                        name: 'V-model the checkboxes',
                        htmlTitle: '<p>V-model the checkboxes</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          likely: [0, 0],
                          enabled: [],
                          progress: 0,
                          check: false
                        },
                        lastModified: '2022-12-19T16:35:56.678Z'
                      },
                      {
                        name:
                          'Apply button triggers a function that applies that array of domains to the domain filter',
                        htmlTitle:
                          '<p>Apply button triggers a function that applies that array of domains to the domain filter</p>',
                        type: 0,
                        flair: {
                          progress: 0,
                          likely: [0, 0],
                          check: false,
                          enabled: [],
                          rating: 0
                        },
                        lastModified: '2022-12-19T16:35:56.677Z'
                      },
                      {
                        name: 'It should change the selected domains and then trigger an init',
                        htmlTitle:
                          '<p>It should change the selected domains and then trigger an init</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          check: false,
                          progress: 0,
                          enabled: [],
                          rating: 0
                        },
                        lastModified: '2022-12-19T16:35:56.678Z'
                      }
                    ]
                  },
                  {
                    name: 'Troubleshooting 2/28/22',
                    htmlTitle: '<p>Troubleshooting 2/28/22</p>',
                    type: 2,
                    flair: {
                      likely: [0, 0],
                      enabled: [],
                      check: false,
                      rating: 0,
                      progress: 0
                    },
                    lastModified: '2022-12-19T16:37:12.438Z',
                    children: [
                      {
                        name: 'SearchResultTreeCard',
                        htmlTitle: '<p>SearchResultTreeCard</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          progress: 0,
                          check: false,
                          likely: [0, 0],
                          rating: 0
                        },
                        lastModified: '2022-12-19T16:30:29.943Z'
                      },
                      {
                        name: 'ResultNode - only 1 result',
                        htmlTitle: '<p>ResultNode - only 1 result</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          likely: [0, 0],
                          check: false,
                          rating: 0,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:30:29.943Z'
                      }
                    ]
                  },
                  {
                    name: 'Improvements 2/25/22',
                    htmlTitle: '<p>Improvements 2/25/22</p>',
                    type: 8,
                    flair: {
                      rating: 0,
                      enabled: [],
                      likely: [0, 0],
                      check: false,
                      progress: 0
                    },
                    lastModified: '2022-12-19T16:37:20.806Z',
                    children: [
                      {
                        name: 'Above the card, up there, in little print (Archive)',
                        htmlTitle: '<p>Above the card, up there, in little print (Archive)</p>',
                        type: 0,
                        flair: {
                          check: false,
                          rating: 0,
                          progress: 0,
                          likely: [0, 0],
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:35:56.679Z'
                      }
                    ]
                  },
                  {
                    name: 'Getting a user object 2/24/22',
                    htmlTitle: '<p>Getting a user object 2/24/22</p>',
                    type: 8,
                    flair: {
                      progress: 0,
                      rating: 0,
                      check: false,
                      likely: [0, 0],
                      enabled: []
                    },
                    lastModified: '2022-12-19T16:37:23.471Z',
                    children: [
                      {
                        name: 'What do I have?',
                        htmlTitle: '<p>What do I have?</p>',
                        type: 0,
                        flair: {
                          progress: 0,
                          enabled: [],
                          likely: [0, 0],
                          check: false,
                          rating: 0
                        },
                        lastModified: '2022-12-19T16:35:57.218Z',
                        children: [
                          {
                            name: 'Users: each user and the panel that goes along with them',
                            htmlTitle:
                              '<p><strong>Users</strong>: each user and the panel that goes along with them</p>',
                            type: 0,
                            flair: {
                              check: false,
                              likely: [0, 0],
                              progress: 0,
                              rating: 0,
                              enabled: []
                            },
                            lastModified: '2022-12-19T16:35:57.101Z',
                            children: [
                              {
                                name: 'users: [',
                                htmlTitle: '<p>users: [</p>',
                                type: 0,
                                flair: {
                                  rating: 0,
                                  enabled: [],
                                  check: false,
                                  likely: [0, 0],
                                  progress: 0
                                },
                                lastModified: '2022-12-19T16:35:56.835Z',
                                children: [
                                  {
                                    name: '{userId, panelId},',
                                    htmlTitle:
                                      '<p><span style="background-color: rgba(198, 228, 246, 0.37);">{userId, panelId},</span></p>',
                                    type: 0,
                                    flair: {
                                      rating: 0,
                                      check: false,
                                      progress: 0,
                                      likely: [0, 0],
                                      enabled: []
                                    },
                                    lastModified: '2022-12-19T16:35:56.680Z'
                                  },
                                  {
                                    name: '{userId, panelId}',
                                    htmlTitle:
                                      '<p><span style="background-color: rgba(198, 228, 246, 0.37);">{userId, panelId}</span></p>',
                                    type: 0,
                                    flair: {
                                      check: false,
                                      likely: [0, 0],
                                      enabled: [],
                                      progress: 0,
                                      rating: 0
                                    },
                                    lastModified: '2022-12-19T16:35:56.679Z'
                                  },
                                  {
                                    name: ']',
                                    htmlTitle: '<p>]</p>',
                                    type: 0,
                                    flair: {
                                      enabled: [],
                                      progress: 0,
                                      check: false,
                                      likely: [0, 0],
                                      rating: 0
                                    },
                                    lastModified: '2022-12-19T16:35:56.679Z'
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            name: 'Authors',
                            htmlTitle: '<p>Authors</p>',
                            type: 0,
                            flair: {
                              progress: 0,
                              check: false,
                              rating: 0,
                              likely: [0, 0],
                              enabled: []
                            },
                            lastModified: '2022-12-19T16:35:56.835Z',
                            children: [
                              {
                                name: '',
                                htmlTitle: '',
                                type: 0,
                                flair: {
                                  check: false,
                                  progress: 0,
                                  likely: [0, 0],
                                  enabled: [],
                                  rating: 0
                                },
                                lastModified: '2022-12-19T16:35:56.679Z'
                              }
                            ]
                          }
                        ]
                      },
                      {
                        name: 'Target: contextRoots - Object',
                        htmlTitle: '<p>Target: contextRoots - Object</p>',
                        type: 0,
                        flair: {
                          check: false,
                          likely: [0, 0],
                          enabled: [],
                          rating: 0,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:35:57.102Z',
                        children: [
                          {
                            name: 'pageId',
                            htmlTitle: '<p>pageId</p>',
                            type: 0,
                            flair: {
                              check: false,
                              enabled: [],
                              rating: 0,
                              progress: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:35:56.836Z',
                            children: [
                              {
                                name: 'pageId',
                                htmlTitle: '<p>pageId</p>',
                                type: 0,
                                flair: {
                                  check: false,
                                  likely: [0, 0],
                                  progress: 0,
                                  rating: 0,
                                  state: 1,
                                  enabled: []
                                },
                                lastModified: '2022-12-19T16:35:56.680Z'
                              },
                              {
                                name: 'userID',
                                htmlTitle: '<p>userID</p>',
                                type: 0,
                                flair: {
                                  enabled: [],
                                  likely: [0, 0],
                                  state: 1,
                                  progress: 0,
                                  rating: 0,
                                  check: false
                                },
                                lastModified: '2022-12-19T16:35:56.681Z'
                              },
                              {
                                name: 'userName',
                                htmlTitle: '<p>userName</p>',
                                type: 0,
                                flair: {
                                  likely: [0, 0],
                                  state: 1,
                                  check: false,
                                  enabled: [],
                                  rating: 0,
                                  progress: 0
                                },
                                lastModified: '2022-12-19T16:35:56.681Z'
                              },
                              {
                                name: 'avatarUrl',
                                htmlTitle: '<p>avatarUrl</p>',
                                type: 0,
                                flair: {
                                  check: false,
                                  likely: [0, 0],
                                  rating: 0,
                                  enabled: [],
                                  progress: 0
                                },
                                lastModified: '2022-12-19T16:35:56.680Z'
                              },
                              {
                                name: 'onUserPanels',
                                htmlTitle: '<p>onUserPanels</p>',
                                type: 0,
                                flair: {
                                  check: false,
                                  enabled: [],
                                  likely: [0, 0],
                                  progress: 0,
                                  rating: 0
                                },
                                lastModified: '2022-12-19T16:35:56.680Z'
                              },
                              {
                                name: 'rootType: panel or archived',
                                htmlTitle: '<p>rootType: panel or archived</p>',
                                type: 0,
                                flair: {
                                  progress: 0,
                                  likely: [0, 0],
                                  state: 1,
                                  enabled: [],
                                  rating: 0,
                                  check: false
                                },
                                lastModified: '2022-12-19T16:35:56.680Z'
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    name: 'How to hook up domains 2/23/22',
                    htmlTitle: '<p>How to hook up domains 2/23/22</p>',
                    type: 8,
                    flair: {
                      progress: 0,
                      check: false,
                      enabled: [],
                      rating: 0,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T16:37:29.103Z',
                    children: [
                      {
                        name: 'V-model the checkboxes',
                        htmlTitle: '<p>V-model the checkboxes</p>',
                        type: 0,
                        flair: {
                          check: false,
                          likely: [0, 0],
                          progress: 0,
                          rating: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:30:29.942Z'
                      },
                      {
                        name:
                          'Apply button triggers a function that applies that array of domains to the domain filter',
                        htmlTitle:
                          '<p>Apply button triggers a function that applies that array of domains to the domain filter</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          progress: 0,
                          enabled: [],
                          likely: [0, 0],
                          check: false
                        },
                        lastModified: '2022-12-19T16:30:29.941Z'
                      },
                      {
                        name: 'It should change the selected domains and then trigger an init',
                        htmlTitle:
                          '<p>It should change the selected domains and then trigger an init</p>',
                        type: 0,
                        flair: {
                          check: false,
                          rating: 0,
                          likely: [0, 0],
                          progress: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:30:29.942Z'
                      }
                    ]
                  },
                  {
                    name: 'Page (parent) each bullet is a page 2/22/22',
                    htmlTitle: '<p>Page (parent) each bullet is a page 2/22/22</p>',
                    type: 8,
                    flair: {
                      likely: [0, 0],
                      check: false,
                      progress: 0,
                      enabled: [],
                      rating: 0
                    },
                    lastModified: '2022-12-19T16:37:32.591Z',
                    children: [
                      {
                        name: 'Title, flair, ICon',
                        htmlTitle: '<p>Title, flair, ICon</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          likely: [0, 0],
                          check: false,
                          rating: 0,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:35:56.682Z'
                      },
                      {
                        name: 'IS IT IN ARCEVE?',
                        htmlTitle: '<p>IS IT IN ARCEVE?</p>',
                        type: 0,
                        flair: {
                          check: false,
                          likely: [0, 0],
                          progress: 0,
                          rating: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:35:56.682Z'
                      },
                      {
                        name: "OnUserPanels (only if it's on multiple)",
                        htmlTitle: "<p>OnUserPanels (only if it's on multiple)</p>",
                        type: 0,
                        flair: {
                          check: false,
                          likely: [0, 0],
                          rating: 0,
                          progress: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:35:56.682Z'
                      },
                      {
                        name: 'NotePages  - children IDs',
                        htmlTitle: '<p>NotePages  - children IDs</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          progress: 0,
                          likely: [0, 0],
                          check: false,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:35:56.682Z'
                      }
                    ]
                  },
                  {
                    name: 'Fixing search for megaContext 2/21/22',
                    htmlTitle: '<p>Fixing search for megaContext 2/21/22</p>',
                    type: 8,
                    flair: {
                      rating: 0,
                      likely: [0, 0],
                      check: false,
                      progress: 0,
                      enabled: []
                    },
                    lastModified: '2022-12-19T16:35:57.423Z',
                    children: [
                      {
                        name: "import { currentUserId } from '@/store/useAuth';",
                        htmlTitle: "<p>import { currentUserId } from '@/store/useAuth';</p>",
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          check: false,
                          progress: 0,
                          enabled: [],
                          rating: 0
                        },
                        lastModified: '2022-12-19T16:35:56.684Z'
                      },
                      {
                        name: 'Vue app',
                        htmlTitle: '<p>Vue app</p>',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          check: false,
                          progress: 0,
                          rating: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:35:57.218Z',
                        children: [
                          {
                            name: 'Context',
                            htmlTitle: '<p>Context</p>',
                            type: 0,
                            flair: {
                              check: false,
                              rating: 0,
                              progress: 0,
                              enabled: [],
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:35:57.102Z',
                            children: [
                              {
                                name: 'Authors',
                                htmlTitle: '<p>Authors</p>',
                                type: 0,
                                flair: {
                                  check: false,
                                  likely: [0, 0],
                                  progress: 0,
                                  rating: 0,
                                  enabled: []
                                },
                                lastModified: '2022-12-19T16:35:56.836Z',
                                children: [
                                  {
                                    name: 'Author 1',
                                    htmlTitle: '<p>Author 1</p>',
                                    type: 0,
                                    flair: {
                                      progress: 0,
                                      enabled: [],
                                      likely: [0, 0],
                                      rating: 0,
                                      check: false
                                    },
                                    lastModified: '2022-12-19T16:35:56.683Z'
                                  },
                                  {
                                    name: 'Author 2',
                                    htmlTitle: '<p>Author 2</p>',
                                    type: 0,
                                    flair: {
                                      enabled: [],
                                      rating: 0,
                                      progress: 0,
                                      likely: [0, 0],
                                      check: false
                                    },
                                    lastModified: '2022-12-19T16:35:56.683Z'
                                  }
                                ]
                              },
                              {
                                name: 'User Panels',
                                htmlTitle: '<p>User Panels</p>',
                                type: 0,
                                flair: {
                                  rating: 0,
                                  enabled: [],
                                  likely: [0, 0],
                                  progress: 0,
                                  check: false
                                },
                                lastModified: '2022-12-19T16:35:56.836Z',
                                children: [
                                  {
                                    name: 'Panel 1',
                                    htmlTitle: '<p>Panel 1</p>',
                                    type: 0,
                                    flair: {
                                      progress: 0,
                                      likely: [0, 0],
                                      enabled: [],
                                      rating: 0,
                                      check: false
                                    },
                                    lastModified: '2022-12-19T16:35:56.683Z'
                                  },
                                  {
                                    name: 'Panel 2',
                                    htmlTitle: '<p>Panel 2</p>',
                                    type: 0,
                                    flair: {
                                      progress: 0,
                                      rating: 0,
                                      check: false,
                                      likely: [0, 0],
                                      enabled: []
                                    },
                                    lastModified: '2022-12-19T16:35:56.683Z'
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        name: 'We don\'t use "Basepage" anymore',
                        htmlTitle: '<p>We don\'t use "Basepage" anymore</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          rating: 0,
                          likely: [0, 0],
                          check: false,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:35:56.682Z'
                      }
                    ]
                  },
                  {
                    name: 'How to build database 2/21/22',
                    htmlTitle: '<p>How to build database 2/21/22</p>',
                    type: 8,
                    flair: {
                      likely: [0, 0],
                      progress: 0,
                      enabled: [],
                      check: false,
                      rating: 0
                    },
                    lastModified: '2022-12-19T16:37:37.543Z',
                    children: [
                      {
                        name: '',
                        htmlTitle: '',
                        type: 0,
                        flair: {
                          likely: [0, 0],
                          enabled: [],
                          check: false,
                          rating: 0,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:35:56.685Z'
                      },
                      {
                        name: 'Collect all the IDs',
                        htmlTitle: '<p>Collect all the IDs</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          rating: 0,
                          progress: 0,
                          check: false,
                          likely: [0, 0]
                        },
                        lastModified: '2022-12-19T16:35:56.936Z',
                        children: [
                          {
                            name: 'instead of base page, get all users',
                            htmlTitle: '<p>instead of base page, get all users</p>',
                            type: 0,
                            flair: {
                              likely: [0, 0],
                              progress: 0,
                              rating: 0,
                              check: false,
                              enabled: []
                            },
                            lastModified: '2022-12-19T16:35:56.685Z'
                          },
                          {
                            name: 'sort it so current user is first',
                            htmlTitle: '<p>sort it so current user is first</p>',
                            type: 0,
                            flair: {
                              progress: 0,
                              check: false,
                              enabled: [],
                              rating: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:35:56.684Z'
                          },
                          {
                            name: '',
                            htmlTitle: '',
                            type: 0,
                            flair: {
                              likely: [0, 0],
                              enabled: [],
                              check: false,
                              progress: 0,
                              rating: 0
                            },
                            lastModified: '2022-12-19T16:35:56.684Z'
                          }
                        ]
                      }
                    ]
                  },
                  {
                    name: 'Ideas on Search for megaContext and shared things 2/18/22',
                    htmlTitle: '<p>Ideas on Search for megaContext and shared things 2/18/22</p>',
                    type: 3,
                    flair: {
                      enabled: [],
                      progress: 0,
                      check: false,
                      rating: 0,
                      likely: [0, 0]
                    },
                    lastModified: '2022-12-19T16:37:44.806Z',
                    children: [
                      {
                        name: 'Design Solution',
                        htmlTitle: '<p>Design Solution</p>',
                        type: '10',
                        flair: {
                          likely: [0, 0],
                          enabled: [],
                          rating: 0,
                          progress: 0,
                          check: false
                        },
                        lastModified: '2022-12-19T16:30:30.027Z',
                        children: [
                          {
                            name: 'Domains: Each domain is a toggle button',
                            htmlTitle: '<p>Domains: Each domain is a toggle button</p>',
                            type: 0,
                            flair: {
                              check: false,
                              likely: [0, 0],
                              rating: 0,
                              progress: 0,
                              enabled: []
                            },
                            lastModified: '2022-12-19T16:30:29.945Z'
                          },
                          {
                            name: 'Archived by me: Toggle button',
                            htmlTitle: '<p>Archived by me: Toggle button</p>',
                            type: 0,
                            flair: {
                              check: false,
                              enabled: [],
                              rating: 0,
                              likely: [0, 0],
                              progress: 0
                            },
                            lastModified: '2022-12-19T16:30:29.945Z'
                          },
                          {
                            name: 'Only my panel: Toggle button',
                            htmlTitle: '<p>Only my panel: Toggle button</p>',
                            type: 0,
                            flair: {
                              check: false,
                              likely: [0, 0],
                              rating: 0,
                              progress: 0,
                              enabled: []
                            },
                            lastModified: '2022-12-19T16:30:29.944Z'
                          }
                        ]
                      },
                      {
                        name: 'Initialize search database',
                        htmlTitle: '<p>Initialize search database</p>',
                        type: 0,
                        flair: {
                          enabled: [],
                          likely: [0, 0],
                          check: false,
                          rating: 0,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:30:30.114Z',
                        children: [
                          {
                            name:
                              'On modal load - default database includes all active domains, and archives',
                            htmlTitle:
                              '<p>On modal load - default database includes all active domains, and archives</p>',
                            type: 0,
                            flair: {
                              progress: 0,
                              likely: [0, 0],
                              rating: 0,
                              enabled: [],
                              check: false
                            },
                            lastModified: '2022-12-19T16:30:29.945Z'
                          },
                          {
                            name:
                              'Domains: Can add/remove domains from search once the modal is open - will re-run init with new root nodes',
                            htmlTitle:
                              '<p>Domains: Can add/remove domains from search once the modal is open - will re-run init with new root nodes</p>',
                            type: 0,
                            flair: {
                              state: 1,
                              rating: 0,
                              check: false,
                              enabled: [],
                              progress: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:30:30.027Z',
                            children: [
                              {
                                name: 'Dropdown, check, check, check',
                                htmlTitle: '<p>Dropdown, check, check, check</p>',
                                type: 0,
                                flair: {
                                  check: false,
                                  rating: 0,
                                  enabled: [],
                                  progress: 0,
                                  likely: [0, 0]
                                },
                                lastModified: '2022-12-19T16:30:29.945Z'
                              }
                            ]
                          }
                        ]
                      },
                      {
                        name: 'Filtering search results',
                        htmlTitle: '<p>Filtering search results</p>',
                        type: 0,
                        flair: {
                          check: false,
                          progress: 0,
                          likely: [0, 0],
                          rating: 0,
                          enabled: []
                        },
                        lastModified: '2022-12-19T16:30:30.114Z',
                        children: [
                          {
                            name:
                              'Archived by: Can I filter the results to show things that only I put in the archive?',
                            htmlTitle:
                              '<p>Archived by: Can I filter the results to show things that only I put in the archive?</p>',
                            type: '0',
                            flair: {
                              likely: [0, 0],
                              state: 1,
                              progress: 0,
                              check: false,
                              enabled: [],
                              rating: 0
                            },
                            lastModified: '2022-12-19T16:30:30.027Z',
                            children: [
                              {
                                name: 'Archived by: Me, Anyone',
                                htmlTitle: '<p>Archived by: Me, Anyone</p>',
                                type: 0,
                                flair: {
                                  check: false,
                                  likely: [0, 0],
                                  enabled: [],
                                  progress: 0,
                                  rating: 0
                                },
                                lastModified: '2022-12-19T16:30:29.944Z'
                              }
                            ]
                          },
                          {
                            name: "In my active window or anyone's?",
                            htmlTitle: "<p>In my active window or anyone's?</p>",
                            type: 0,
                            flair: {
                              likely: [0, 0],
                              state: 1,
                              progress: 0,
                              enabled: [],
                              rating: 0,
                              check: false
                            },
                            lastModified: '2022-12-19T16:30:29.944Z'
                          },
                          {
                            name: 'Can I filter results to show only starred items?',
                            htmlTitle: '<p>Can I filter results to show only starred items?</p>',
                            type: 0,
                            flair: {
                              rating: 0,
                              likely: [0, 0],
                              progress: 0,
                              check: false,
                              enabled: []
                            },
                            lastModified: '2022-12-19T16:30:29.944Z'
                          },
                          {
                            name: 'Default: Archived by: anyone, panel: Everyone, not starred, ',
                            htmlTitle:
                              '<p>Default: Archived by: anyone, panel: Everyone, not starred, </p>',
                            type: 0,
                            flair: {
                              check: false,
                              rating: 0,
                              enabled: [],
                              progress: 0,
                              likely: [0, 0]
                            },
                            lastModified: '2022-12-19T16:30:29.943Z'
                          }
                        ]
                      },
                      {
                        name: 'Displaying results',
                        htmlTitle: '<p>Displaying results</p>',
                        type: 0,
                        flair: {
                          rating: 0,
                          enabled: [],
                          check: false,
                          likely: [0, 0],
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:30:30.027Z',
                        children: [
                          {
                            name: 'Starred items should appear first if there are any',
                            htmlTitle: '<p>Starred items should appear first if there are any</p>',
                            type: 0,
                            flair: {
                              enabled: [],
                              progress: 0,
                              rating: 0,
                              likely: [0, 0],
                              check: false
                            },
                            lastModified: '2022-12-19T16:30:29.943Z'
                          }
                        ]
                      },
                      {
                        name: 'What about breadcrumbs? Can we search breadcrumbs somehow?',
                        htmlTitle:
                          '<p>What about breadcrumbs? Can we search breadcrumbs somehow?</p>',
                        type: '1',
                        flair: {
                          likely: [0, 0],
                          rating: 0,
                          enabled: [],
                          check: false,
                          progress: 0
                        },
                        lastModified: '2022-12-19T16:30:29.944Z'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            name: 'Organizing a customer interview project [video]',
            htmlTitle: '<p>Organizing a customer interview project [video]</p>',
            type: 8,
            flair: {
              enabled: [],
              rating: 0,
              progress: 0,
              likely: [0, 0],
              check: false
            },
            lastModified: '2023-01-31T19:02:28.424Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=eLVaWbixhD0',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=eLVaWbixhD0" target="_blank">https://www.youtube.com/watch?v=eLVaWbixhD0</a></p>',
                type: 0,
                flair: {
                  progress: 0,
                  rating: 0,
                  check: false,
                  likely: [0, 0],
                  enabled: ['cardify']
                },
                lastModified: '2023-02-01T21:45:48.356Z'
              }
            ]
          }
        ]
      },
      {
        name: 'What to do next - Try it yourself!',
        htmlTitle: '<p>What to do next - Try it yourself!</p>',
        type: '10',
        flair: {
          enabled: [],
          rating: 0,
          likely: [0, 0],
          state: null,
          progress: 0,
          check: false
        },
        lastModified: '2023-02-01T21:47:38.571Z',
        children: [
          {
            name: 'Just dive in - here are a few ideas to try.',
            htmlTitle: '<p>Just dive in - here are a few ideas to try.</p>',
            type: 12,
            flair: {
              likely: [0, 0],
              progress: 0,
              rating: 0,
              check: false,
              enabled: []
            },
            lastModified: '2023-01-30T15:52:34.318Z'
          },
          {
            name: 'Rename the guide.',
            htmlTitle: '<p>Rename the guide.</p>',
            type: 3,
            flair: {
              progress: 0,
              rating: 0,
              likely: [0, 0],
              check: false,
              enabled: []
            },
            lastModified: '2023-02-01T21:46:13.813Z',
            children: [
              {
                name:
                  'Our notes always change meaning as we make progress on something, embrace that! It no longer makes sense to have this guide called "Hi, welcome to Context blah blah blah".',
                htmlTitle:
                  '<p>Our notes always change meaning as we make progress on something, embrace that! It no longer makes sense to have this guide called "Hi, welcome to Context blah blah blah".</p>',
                type: '0',
                flair: {
                  rating: 0,
                  enabled: [],
                  check: false,
                  likely: [0, 0],
                  progress: 0
                },
                lastModified: '2023-02-01T21:46:26.775Z'
              },
              {
                name:
                  'Just call it something like "Context Guide" or "Context Tutorial." That will make more sense going forward.',
                htmlTitle:
                  '<p>Just call it something like "Context Guide" or "Context Tutorial." That will make more sense going forward.</p>',
                type: '0',
                flair: {
                  check: false,
                  progress: 0,
                  likely: [0, 0],
                  rating: 0,
                  enabled: []
                },
                lastModified: '2023-02-01T21:46:38.358Z'
              }
            ]
          },
          {
            name: 'Create a new sheet and organize your week.',
            htmlTitle: '<p>Create a new sheet and organize your week.</p>',
            type: 3,
            flair: {
              enabled: [],
              progress: 0,
              check: false,
              rating: 0,
              likely: [0, 0],
              state: null
            },
            lastModified: '2023-01-30T17:25:05.977Z',
            children: [
              {
                name: 'Just start making a list of things you need to do this week.',
                htmlTitle: '<p>Just start making a list of things you need to do this week.</p>',
                type: 0,
                flair: {
                  enabled: [],
                  progress: 0,
                  check: false,
                  rating: 0,
                  likely: [0, 0]
                },
                lastModified: '2023-01-30T16:14:35.552Z'
              },
              {
                name: 'Once you have your list, group and prioritize stuff.',
                htmlTitle: '<p>Once you have your list, group and prioritize stuff.</p>',
                type: 0,
                flair: {
                  progress: 0,
                  check: false,
                  likely: [0, 0],
                  enabled: [],
                  rating: 0
                },
                lastModified: '2023-01-30T16:15:00.144Z'
              },
              {
                name:
                  'If you have more thoughts or additional info on a task, nest some notes underneath it.',
                htmlTitle:
                  '<p>If you have more thoughts or additional info on a task, nest some notes underneath it.</p>',
                type: 0,
                flair: {
                  check: false,
                  likely: [0, 0],
                  enabled: [],
                  rating: 0,
                  progress: 0
                },
                lastModified: '2023-01-30T16:15:18.752Z'
              },
              {
                name: 'https://www.youtube.com/watch?v=_24v-L1sXl0',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=_24v-L1sXl0" target="_blank">https://www.youtube.com/watch?v=_24v-L1sXl0</a></p>',
                type: 0,
                flair: {
                  progress: 0,
                  rating: 0,
                  enabled: ['cardify'],
                  check: false,
                  likely: [0, 0]
                },
                lastModified: '2023-01-30T17:24:52.748Z'
              }
            ]
          },
          {
            name: 'Start capturing some shower thoughts.',
            htmlTitle: '<p>Start capturing some shower thoughts.</p>',
            type: 3,
            flair: {
              rating: 0,
              enabled: [],
              check: false,
              likely: [0, 0],
              progress: 0
            },
            lastModified: '2023-01-30T15:49:53.288Z',
            children: [
              {
                name:
                  'Just start putting down some ideas. Then once you have them down, try breaking them into a few different sections.',
                htmlTitle:
                  '<p>Just start putting down some ideas. Then once you have them down, try breaking them into a few different sections.</p>',
                type: 0,
                flair: {
                  progress: 0,
                  enabled: [],
                  check: false,
                  likely: [0, 0],
                  rating: 0
                },
                lastModified: '2023-01-30T15:21:14.816Z'
              }
            ]
          }
        ]
      },
      {
        name: 'How do I get the most out of Context?',
        htmlTitle: '<p>How do I get the most out of Context?</p>',
        type: '10',
        flair: {
          enabled: [],
          progress: 0,
          check: false,
          likely: [0, 0],
          rating: 0,
          state: 2
        },
        lastModified: '2023-02-01T21:49:17.582Z',
        children: [
          {
            name: 'Organize your thoughts around something you want to make progress on.',
            htmlTitle:
              '<p>Organize your thoughts around something you want to make progress on.</p>',
            type: 3,
            flair: {
              rating: 0,
              check: false,
              progress: 0,
              likely: [0, 0],
              enabled: []
            },
            lastModified: '2023-01-30T15:49:53.897Z',
            children: [
              {
                name:
                  "Here's a little approach we often take. We call it GOW, but need a better acronym.",
                htmlTitle:
                  "<p>Here's a little approach we often take. We call it GOW, but need a better acronym.</p>",
                type: 12,
                flair: {
                  rating: 0,
                  check: false,
                  enabled: [],
                  likely: [0, 0],
                  progress: 0
                },
                lastModified: '2023-01-30T15:23:06.122Z'
              },
              {
                name:
                  'Get it down - just make a new sheet, call it "Thoughts on Project", and write down what ever is kicking around in your head about it.',
                htmlTitle:
                  '<p><strong>Get it down </strong>- just make a new sheet, call it "Thoughts on Project", and write down what ever is kicking around in your head about it.</p>',
                type: '0',
                flair: {
                  rating: 0,
                  check: false,
                  progress: 0,
                  enabled: [],
                  likely: [0, 0]
                },
                lastModified: '2023-01-30T15:22:56.669Z'
              },
              {
                name:
                  'Organize it - Now that you\'ve got it down, take a look at it. Make a few sections to act as piles, so you can sort stuff. Common sections might be "Initial thoughts", "Concerns", "Ideas", or just categorize by subject.',
                htmlTitle:
                  '<p><strong>Organize it</strong> - Now that you\'ve got it down, take a look at it. Make a few sections to act as piles, so you can sort stuff. Common sections might be "Initial thoughts", "Concerns", "Ideas", or just categorize by subject.</p>',
                type: '0',
                flair: {
                  enabled: [],
                  progress: 0,
                  likely: [0, 0],
                  rating: 0,
                  check: false
                },
                lastModified: '2023-01-30T15:25:28.813Z'
              },
              {
                name:
                  'Work though it - Now that you can see what you\'ve got, start working through it. Here are a few section that might be helpful to make, to prompt yourself - "Purpose - what am I trying to do", "What\'s hard about making progress on this", "Things to try next."',
                htmlTitle:
                  '<p><strong>Work though it</strong> - Now that you can see what you\'ve got, start working through it. Here are a few section that might be helpful to make, to prompt yourself - "Purpose - what am I trying to do", "What\'s hard about making progress on this", "Things to try next."</p>',
                type: '0',
                flair: {
                  rating: 0,
                  check: false,
                  enabled: [],
                  progress: 0,
                  likely: [0, 0]
                },
                lastModified: '2023-01-30T15:27:20.945Z'
              },
              {
                name:
                  "That's it. If you come up with some ideas on things to try next, you can drag those notes out and put them at the top of your notes panel so they are front and center.",
                htmlTitle:
                  "<p>That's it. If you come up with some ideas on things to try next, you can drag those notes out and put them at the top of your notes panel so they are front and center.</p>",
                type: '0',
                flair: {
                  enabled: [],
                  check: false,
                  rating: 0,
                  likely: [0, 0],
                  progress: 0
                },
                lastModified: '2023-01-30T15:28:12.104Z'
              }
            ]
          }
        ]
      },
      {
        name: 'Short FAQ videos',
        htmlTitle: '<p>Short FAQ videos</p>',
        type: '10',
        flair: {
          likely: [0, 0],
          progress: 0,
          enabled: [],
          check: false,
          rating: 0
        },
        lastModified: '2023-01-30T17:25:43.821Z',
        children: [
          {
            name: 'What am I looking at here?',
            htmlTitle: '<p>What am I looking at here?</p>',
            type: '1',
            flair: {
              enabled: [],
              check: false,
              likely: [0, 0],
              progress: 0,
              rating: 0
            },
            lastModified: '2023-01-24T14:53:55.952Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=foTr2G2ghgQ',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=foTr2G2ghgQ" target="_blank">https://www.youtube.com/watch?v=foTr2G2ghgQ</a></p>',
                type: 0,
                flair: {
                  check: false,
                  progress: 0,
                  enabled: ['cardify'],
                  likely: [0, 0],
                  rating: 0
                },
                lastModified: '2023-01-24T14:36:35.627Z'
              }
            ]
          },
          {
            name: 'How do I open notes?',
            htmlTitle: '<p>How do I open notes?</p>',
            type: '1',
            flair: {
              progress: 0,
              enabled: [],
              check: false,
              likely: [0, 0],
              rating: 0
            },
            lastModified: '2023-01-24T14:39:45.688Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=foTr2G2ghgQ',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=foTr2G2ghgQ" target="_blank">https://www.youtube.com/watch?v=foTr2G2ghgQ</a></p>',
                type: 0,
                flair: {
                  likely: [0, 0],
                  enabled: ['cardify'],
                  check: false,
                  rating: 0,
                  progress: 0
                },
                lastModified: '2023-01-24T14:40:21.482Z'
              }
            ]
          },
          {
            name: 'What is the difference between notes on the left and notes on the right?',
            htmlTitle:
              '<p>What is the difference between notes on the left and notes on the right?</p>',
            type: '1',
            flair: {
              progress: 0,
              rating: 0,
              check: false,
              likely: [0, 0],
              enabled: []
            },
            lastModified: '2023-01-24T14:47:57.667Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=pHc4a1eqqag',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=pHc4a1eqqag" target="_blank">https://www.youtube.com/watch?v=pHc4a1eqqag</a></p>',
                type: 0,
                flair: {
                  likely: [0, 0],
                  check: false,
                  progress: 0,
                  rating: 0,
                  enabled: ['cardify']
                },
                lastModified: '2023-01-24T14:48:02.513Z'
              }
            ]
          },
          {
            name: 'How do I create new notes?',
            htmlTitle: '<p>How do I create new notes?</p>',
            type: 1,
            flair: {
              check: false,
              enabled: [],
              progress: 0,
              likely: [0, 0],
              rating: 0
            },
            lastModified: '2023-01-24T14:50:17.658Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=ygWSP697fJ4',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=ygWSP697fJ4" target="_blank">https://www.youtube.com/watch?v=ygWSP697fJ4</a></p>',
                type: 0,
                flair: {
                  enabled: ['cardify'],
                  rating: 0,
                  progress: 0,
                  likely: [0, 0],
                  check: false
                },
                lastModified: '2023-01-24T14:50:22.682Z'
              }
            ]
          },
          {
            name: 'How do I make sub-notes or nested notes?',
            htmlTitle: '<p>How do I make sub-notes or nested notes?</p>',
            type: 1,
            flair: {
              enabled: [],
              likely: [0, 0],
              check: false,
              rating: 0,
              progress: 0
            },
            lastModified: '2023-01-24T14:42:51.208Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=lHlh0z3qUUQ&feature=youtu.be',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=lHlh0z3qUUQ&amp;feature=youtu.be" target="_blank">https://www.youtube.com/watch?v=lHlh0z3qUUQ&amp;feature=youtu.be</a></p>',
                type: 0,
                flair: {
                  check: false,
                  progress: 0,
                  enabled: ['cardify'],
                  likely: [0, 0],
                  rating: 0
                },
                lastModified: '2023-01-24T14:42:46.092Z'
              }
            ]
          },
          {
            name: 'How do I use icons?',
            htmlTitle: '<p>How do I use icons?</p>',
            type: 1,
            flair: {
              enabled: [],
              rating: 0,
              check: false,
              likely: [0, 0],
              progress: 0
            },
            lastModified: '2023-01-24T14:45:55.707Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=DmTAWE83Ai0',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=DmTAWE83Ai0" target="_blank">https://www.youtube.com/watch?v=DmTAWE83Ai0</a></p>',
                type: 0,
                flair: {
                  likely: [0, 0],
                  enabled: ['cardify'],
                  rating: 0,
                  check: false,
                  progress: 0
                },
                lastModified: '2023-01-24T14:45:58.658Z'
              }
            ]
          },
          {
            name: "What's up with sections?",
            htmlTitle: "<p>What's up with sections?</p>",
            type: 1,
            flair: {
              likely: [0, 0],
              rating: 0,
              check: false,
              progress: 0,
              enabled: []
            },
            lastModified: '2023-01-24T14:54:24.991Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=kijxbQUQr40',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=kijxbQUQr40" target="_blank">https://www.youtube.com/watch?v=kijxbQUQr40</a></p>',
                type: 0,
                flair: {
                  check: false,
                  rating: 0,
                  progress: 0,
                  enabled: ['cardify'],
                  likely: [0, 0]
                },
                lastModified: '2023-01-24T14:54:30.013Z'
              }
            ]
          },
          {
            name: 'How do I archive notes?',
            htmlTitle: '<p>How do I archive notes?</p>',
            type: 1,
            flair: {
              likely: [0, 0],
              enabled: [],
              check: false,
              rating: 0,
              progress: 0
            },
            lastModified: '2023-01-24T14:52:21.145Z',
            children: [
              {
                name: 'https://www.youtube.com/watch?v=GPA3HrBHc18',
                htmlTitle:
                  '<p><a href="https://www.youtube.com/watch?v=GPA3HrBHc18" target="_blank">https://www.youtube.com/watch?v=GPA3HrBHc18</a></p>',
                type: 0,
                flair: {
                  enabled: ['cardify'],
                  likely: [0, 0],
                  progress: 0,
                  check: false,
                  rating: 0
                },
                lastModified: '2023-01-24T14:52:24.866Z'
              }
            ]
          }
        ]
      }
    ]
  }
];
